export class ApplyRewards {
    membershipid: number;
    references: Array<string>;
}
